<template>
    <div class="dft-container2">
        <div class="time-box">
            时间选择：<el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div class="number-box">
            <div class="number-item">
                <img src="@/assets/images/data_report/icon-points1.png" alt="" style="width: 40px;height: 40px;"></img>
                <div class="item-bottom">
                    <span>{{ modelData.allScore || 0 }}</span>
                    <span class="item-des">总积分</span>
                </div>
            </div>
            <div class="number-item">
                <img src="@/assets/images/data_report/icon-points2.png" alt="" style="width: 40px;height: 40px;"></img>
                <div class="item-bottom">
                    <span>{{ modelData.remainScore || 0 }}</span>
                    <span class="item-des">账号剩余积分</span>
                </div>
            </div>
            <div class="number-item">
                <img src="@/assets/images/data_report/icon-points3.png" alt="" style="width: 40px;height: 40px;"></img>
                <div class="item-bottom">
                    <span>{{ modelData.usedScore || 0 }}</span>
                    <span class="item-des">累计消耗积分</span>
                </div>
            </div>
        </div>
        <!-- 积分使用趋势 -->
        <div class="container-chart-box">
            <div class="container-chart" id="lineChart">

            </div>
        </div>
        <div class="container-bottom-box">
            <div class="container-bottom-item">
                <div class="container-bottom-left-chart" id="pieChart">

                </div>
            </div>
            <div class="container-bottom-item">
                <div class="container-bottom-right-chart">
                    <span style="font-size: 18px;font-weight: 600;margin: 10px;">积分消耗</span>

                    <div class="table-header">
                        <div class="item-box">来源</div>
                        <div class="item-box">全额</div>
                        <div class="item-progress">占比率</div>
                    </div>
                    <div class="table-item" v-for="(item, index) in tableData" :key="index">
                        <div class="item-box">{{ item.name }}</div>
                        <div class="item-box">{{ item.value }}</div>
                        <div class="item-progress">

                            <el-progress :percentage="item.rate" :stroke-width="11" color="#6395FA"></el-progress>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      dateTime: null,
      modelData: {},
      tableData: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 }
      ]
    }
  },
  watch: {
    dateTime (val) {
      this.getData()
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.getModelData1()
      this.initLineChart()
      this.initPieChart()
      this.getModelData2()
    },
    async getModelData1 () {
      //
      let startTime = null
      let endTime = null
      if (this.dateTime) {
        startTime = this.dateTime[0]
        endTime = this.dateTime[1]
      }
      let res = await this.$http.post('/dataReport/dataReportScore1', { startTime: startTime, endTime: endTime })
      if (res.data.code == 200) {
        this.modelData = res.data.data
      }
    },
    // 初始化折线图 商品数据统计
    async initLineChart () {
      let startTime = null
      let endTime = null
      if (this.dateTime) {
        startTime = this.dateTime[0]
        endTime = this.dateTime[1]
      }
      let xAxis = []
      let series1 = []
      let series2 = []
      let res = await this.$http.post('/dataReport/dataReportScoreChart', {
        startTime: startTime,
        endTime: endTime
      })
      if (res.data.code == 200) {
        xAxis = res.data.data.xList
        series1 = res.data.data.y1List
        series2 = res.data.data.y2List
      }

      let lineChart = this.$echarts.init(document.getElementById('lineChart'))
      let option = {
        title: {
          text: '积分使用趋势'
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(76, 75, 75, 0.73)',
          textStyle: {
            color: '#FFF'
          }
        },

        /*  dataZoom: [
                     {
                         type: 'inside',
                         start: 0,
                         end: 100
                     },
                     {
                         start: 0,
                         end: 100
                     }
                 ], */
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '积分积累',
            type: 'line',
            symbolSize: 12, // 设置圆圈的大小为10
            // 设置折线颜色
            itemStyle: {
              normal: {
                color: '#0C67F5', // 圆心颜色
                lineStyle: {
                  color: '#0C67F5' // 线的颜色
                }
              }
            },
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置，对于直线图，通常设置为 'top'
              formatter: '{c}' // 标签内容格式器，'{c}' 代表数据值
            },
            data: series2
          },
          {
            name: '积分消耗',
            symbolSize: 12, // 设置圆圈的大小为10
            type: 'line',
            // 设置折线颜色
            itemStyle: {
              normal: {
                color: '#5AD8A6', // 圆心颜色
                lineStyle: {
                  color: '#5AD8A6' // 线的颜色
                }
              }
            },
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置，对于直线图，通常设置为 'top'
              formatter: '{c}' // 标签内容格式器，'{c}' 代表数据值
            },
            data: series1
          }

        ]
      }
      lineChart.setOption(option)
      window.addEventListener('resize', () => {
        lineChart.resize()
      })
    },
    /* 积分来源分析 */
    async initPieChart () {
      let startTime = null
      let endTime = null
      if (this.dateTime) {
        startTime = this.dateTime[0]
        endTime = this.dateTime[1]
      }
      let res = await this.$http.post('/dataReport/ScoreSource', {
        startTime: startTime,
        endTime: endTime
      })
      let series1 = []
      let names = []
      // 1：签到增加 2：浏览商品增加  3：完成今日下单增加   4：后台赠送  5：开通会员扣除    6积分兑换扣除 7完善身份信息增加
      if (res.data.code == 200) {
        series1 = res.data.data
      }

      let pieChart = this.$echarts.init(document.getElementById('pieChart'))
      let option = {
        title: {
          text: '积分来源分析'
        },
        legend: {
          right: 30,
          top: 30,
          icon: 'roundRect',
          orient: 'vertical',
          align: 'right'
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(76, 75, 75, 0.73)',
          textStyle: {
            color: '#FFF'
          },
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: '积分来源分析',
            type: 'pie',
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}: {d}%'
              }
            },
            data: series1
          }
        ]
      }
      pieChart.setOption(option)
      window.addEventListener('resize', () => {
        pieChart.resize()
      })
    },
    // 积分消耗
    //
    async getModelData2 () {
      let startTime = null
      let endTime = null
      if (this.dateTime) {
        startTime = this.dateTime[0]
        endTime = this.dateTime[1]
      }
      let res = await this.$http.post('/dataReport/ScoreConsume', { startTime: startTime, endTime: endTime })
      if (res.data.code == 200) {
        this.tableData = res.data.data
      }
    }
  }
}
</script>

<style scoped lang="scss">
.time-box {
    width: 100%;
    background: #FFF;
    padding: 20px;
    border-radius: 4px;

}

.number-box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .number-item {
        width: 28%;
        display: flex;
        align-items: center;
        justify-content: start;
        background: #FFF;
        padding: 30px;
        border-radius: 4px;

        span {
            font-size: 20px;
            font-weight: bold;
        }

        .item-bottom {
            margin-left: 20px;
            display: flex;
            flex-direction: column;

            .item-des {
                color: rgba(76, 75, 75, 0.51);
                font-size: 13px;
                font-family: Arial-regular;
                margin-top: 10px;
            }

        }

    }
}

.container-chart-box {
    width: 100%;
    margin-top: 20px;
    background: #FFF;
    border-radius: 4px;
    padding: 20px;

    .container-chart {
        width: 100%;
        height: 500px;
        background: #FFF;

    }
}

.container-bottom-box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .container-bottom-item {
        width: 47%;
        height: 400px;
        background: #FFF;
        border-radius: 4px;
        padding: 20px;

        .container-bottom-left-chart {
            width: 100%;
            height: 400px;
            background: #FFF;
        }

        .container-bottom-right-chart {
            width: 100%;
            height: 400px;
            background: #FFF;

            .table-header {
                background-color: rgba(99, 149, 250, 0.1);
                padding: 10px 0;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
            }

            .table-item {
                padding: 10px 0;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .item-box {
                flex: 1;
                text-align: center;
            }

            .item-progress {
                flex: 2;
                text-align: center;
            }
        }
    }
}
</style>
